import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SidebarMenuItemContainer } from '../SidebarMenuItem/styled';
import { SIDEBAR_PADDING } from '../config';
const NEGATIVE_SPACING = `calc((${SIDEBAR_PADDING} / 2) * -1)`;
const POSITIVE_SPACING = `calc(${SIDEBAR_PADDING} / 2)`;
export const SidebarMenuUserContainer = styled(SidebarMenuItemContainer) `
  margin: ${NEGATIVE_SPACING};
  padding: ${POSITIVE_SPACING};
  width: calc(100% + ${SIDEBAR_PADDING});
  background-color: transparent;

  ${(props) => props.$minimized &&
    `
    margin: 0;
    padding: 0;
    width: 100%;
    border-radius: 50%;
  `}
`;
export const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  max-width: 100%;
  overflow: hidden;
  margin-left: ${theme.spacing.sm};
`;
